import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var stretch_wide_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M16 5.5H8V4h8v1.5ZM16 20H8v-1.5h8V20ZM5 9h14v6H5V9Z" }) });
export {
  stretch_wide_default as default
};
//# sourceMappingURL=stretch-wide.js.map
